import GameParameterInterface from '@/models/game/parameters/interface'

export interface JankenParameterJson {
  score: number,
  rouletteScores: JankenRouletteScore[]
  prize: JankenPrize
}

interface JankenPrize {
  prizeImage: string,
  guideUrl: string,
}

interface JankenRouletteScore {
  score: number
}

export default class JankenParameter implements GameParameterInterface {
  constructor(private parameter: JankenParameterJson) { }

  createSetOption(): any {
    return {
      rouletteScores: this.parameter.rouletteScores,
      prize: this.parameter.prize,
      result: {
        score: this.parameter.score,
      },
    }
  }

  get guideUrl(): string {
    return this.parameter.prize.guideUrl
  }
}
